export default [
  {
    id: 1,
    image: '/assets/img/tb-portfolio.png',
    alt: 'Travel Bucket Project',
    title: 'Travel Bucket',
    description: 'A Reddit-inspired social media app for sharing posts and comments within a travel blog community.',
    github: 'https://github.com/ARodriguezHacks/travel-bucket-app',
    logo: '/assets/icons/002-heroku.png',
    deployedAlt: 'Heroku Logo',
    deployed: 'https://travelbucketapp.herokuapp.com'
  },
  {
    id: 2,
    image: '/assets/img/speedyspanish-img1-min.png',
    alt: 'SpeedySpanish Quiz Project',
    title: 'SpeedySpanish Quiz',
    description: 'A multiple-choice quiz app to learn Spanish.',
    github: 'https://github.com/ARodriguezHacks/speedy-spanish-quiz',
    logo: '/assets/icons/iconfinder_netlify_4691413.png',
    deployedAlt: 'Netlify Logo',
    deployed: 'https://speedyspanishquiz.netlify.com/'
  },
  {
    id: 3,
    image: '/assets/img/parle-chat-portfolio.png',
    alt: 'Parle! Chat App Project',
    title: 'Parle!',
    description: 'A React.js chat app built with a realtime database',
    github: 'https://github.com/ARodriguezHacks/parle-app',
    logo: '/assets/icons/icons8-firebase-50.png',
    deployedAlt: 'Firebase Logo',
    deployed: 'https://my-firebase-react-chatapp.web.app'
  },
  {
    id: 4,
    image: '/assets/img/favorite-fonts-min.png',
    alt: 'Favorite Fonts Project',
    title: 'Favorite Fonts',
    description: 'A Google Fonts landing page clone built with plain JavaScript and FlexBox.',
    github: 'https://github.com/ARodriguezHacks/favorite-fonts',
    logo: '/assets/icons/002-heroku.png',
    deployedAlt: 'Heroku Logo',
    deployed: 'https://angies-favorite-fonts.herokuapp.com/'
  }
]